import React from "react";
import "./buttonComponent.css";

const ButtonComponent = ({
  buttonText,
  type = "filled",
  onClick,
  style,
  className,
  id
}) => {
  return (
    <button
      id={id}
      className={`custom-button  ${className} ${
        type === "filled" ? "filled" : "transparent"
      }`}
      onClick={onClick}
      style={style}
    >
      {buttonText}
    </button>
  );
};

export default ButtonComponent;
